import React from "react";
import { StyleCardHeader } from "./style";

const CardHeader = ({ title, icon, justifyAround, stylecardheader }: any) => {
  return (
    <StyleCardHeader
      $justifyAround={justifyAround}
      stylecardheader={stylecardheader}
    >
      {title} {icon}
    </StyleCardHeader>
  );
};

export default CardHeader;
